import React from 'react';
import { PAPERLESS_TERMS_MODAL } from '../../../../redux/modules/modals/modals.module';
import Checkbox from '../../../Shared/Checkbox/Checkbox';
import './PaperlessOptIn.scss';
import TRP from '../../../Shared/TRP/TRP';

const PaperlessOptIn = ({
  openModal,
  paperlessChecked,
  updatePaperlessChecked,
}) => (
  <div className="paperless-optin-container">
    <div className="paperless-optin-checkbox-container e2e-paperless-checkbox">
      <Checkbox
        ariaLabel={'paperless checkbox'}
        checked={paperlessChecked}
        onClick={() => updatePaperlessChecked(!paperlessChecked)}
      />
    </div>
    <div
      className="paperless-optin-header e2e-paperless-header"
      onClick={() => updatePaperlessChecked(!paperlessChecked)}
    >
      Go Paperless
    </div>

    <div className="paperless-optin-copy e2e-paperless-copy">
      By checking this box and clicking “Submit,” below, you consent to
      participate in Paperless Services to receive all <TRP /> fund (and <TRP />{' '}
      Brokerage, if applicable) statements and confirmations and <TRP /> fund
      prospectuses, shareholder reports, and proxy materials for all of your
      eligible accounts electronically instead of by U.S. Mail and acknowledge
      that you have read and agree to the Paperless Terms, Conditions, and
      Eligibility Electronic Consent Form in the link below. This election
      applies to this and all future transactions and document delivery for all
      eligible accounts and will override any existing paperless elections you
      have made. When you select email delivery, you'll receive an email notice
      alerting you that your documents are ready to view online to view, print,
      or download. You can access the documents securely by logging onto your
      account online. You may change your Paperless Preferences at any time by
      logging into your account and selecting E-Mail Preferences within the
      Profile section.
      <div>
        <button
          id="paperless-terms-link"
          className="paperless-optin-terms-link"
          type="button"
          onClick={() => openModal(PAPERLESS_TERMS_MODAL)}
        >
          View Paperless Terms, Conditions, and Eligibility Electronic Consent
          Form
        </button>
      </div>
    </div>
  </div>
);

export default PaperlessOptIn;
